import React, { useEffect } from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { commonServices } from '../../../../api/services/commonServices';
import moment from 'moment';

import {
  setCalendarData,
  setDashboardCalendarLoader,
} from '../../../../infra/aggregates/dashboardCalendarSlice';

const DTOAttendanceCalendarData = (prop) => {
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  const getDashboardCalendarDataCall = () => {
    dispatch(setDashboardCalendarLoader(true));
    const _todayDate = new Date();
    const getCurrentMonth = moment(_todayDate).format('M');
    const getCurrentYear = moment(_todayDate).get('year');

    if (getCurrentYear && getCurrentMonth) {
      commonServices
        .getAttendanceCalendar(
          selector.authSlice.company_id,
          selector.authSlice.emp_id,
          getCurrentMonth,
          getCurrentYear,
        )
        .then((response) => {
          if (response?.data?.leaves) {
            prop.setAllDashboardCalendarData(response?.data);
            dispatch(setDashboardCalendarLoader(false));
          }
        })
        .catch((err) => {
          dispatch(setDashboardCalendarLoader(false));
          console.log(err);
        });
    }
  };
  useEffect(() => {
    getDashboardCalendarDataCall();
  }, []);

  return <></>;
};

export default DTOAttendanceCalendarData;
